import type {AxiosRequestConfig} from 'axios';

export class GetChangeLogs {
  private readonly changeLogRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/changelogs',
    params: {},
  };

  params(params: object) {
    this.changeLogRequest.params = params;
    return this;
  }

  build() {
    return this.changeLogRequest;
  }
}
